module.exports =
  base: '/coupa'
  punchout: '/coupa/punchout'
  checkout: '/coupa/checkout'
  purchaseOrder: '/coupa/purchaseOrder'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/coupa.coffee